import React, { useEffect, useState } from 'react';
import RootLayout from 'layouts/RootLayout';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import { liff } from '@line/liff';
import { useTranslation } from 'react-i18next';

const LIFF_ID = process.env.REACT_APP_CLINIC_REG_LIFF_ID as string;
const backendEventUrl = process.env.REACT_APP_BACKEND_EVENT_URL as string;

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 400,
  bgcolor: 'background.paper',
  border: '0px solid #000',
  boxShadow: 24,
  p: 1,
};

const initializeLIFF = async () => {
  try {
    await liff.init({ liffId: LIFF_ID });

    if (!liff.isLoggedIn()) {
      liff.login();
    }

    return liff;
  } catch (error: unknown) {
    console.error('初始化 liff 時出錯：', error);
  }
};

const RegClinic = () => {
  const { t } = useTranslation("clinic");
  const [liffClientObject, setLiffClientObject] = useState(null);
  const [facilityName, setFacilityName] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [position, setPosition] = useState('');
  const [exists, setExists] = useState(false);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initialize = async () => {
      const liffObject = await initializeLIFF();
      setLiffClientObject(liffObject);

      if (liffObject) {
        const profile = await liffObject.getProfile();
        const accessToken = liffObject.getAccessToken();

        const response = await fetch(`${backendEventUrl}/facility/register/getInfo`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            lineId: profile.userId,
            accessToken: accessToken,
          }),
        });

        const data = await response.json();
        setExists(data.exists);
      }
      setLoading(false);
    };
    initialize();
  }, []);

  const handleSubmit = async () => {
    if (liffClientObject) {
      const profile = await liffClientObject.getProfile();
      const accessToken = liffClientObject.getAccessToken();
      const lineId = profile.userId;
      const lineName = profile.displayName;

      const response = await fetch(`${backendEventUrl}/facility/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          lineId: lineId,
          accessToken: accessToken,
          lineName: lineName,
          facilityName: facilityName,
          name: name,
          position: position,
          phone: phone,
        }),
      });

      const data = await response.json();

      if ((response.status === 200 || response.status === 201) && data.lineId === lineId) {
        setMessage(t('reg.successMsg'));
        setExists(true);
      } else {
        setMessage(t('reg.failMsg'));
      }
    }
  };

  const handleClose = () => {
    liff.closeWindow();
  };

  return (
    <RootLayout title={t('reg.title')}>
      <Box sx={style}>
        {loading ? (
          <CircularProgress />
        ) : exists ? (
          <>
            <Typography variant="h6" component="h2">
              {message ? message : t('reg.alreadyApplied')}
            </Typography>
            <Button onClick={handleClose} variant="contained" color="primary" fullWidth>
              {t('common:action.close')}
            </Button>
          </>
        ) : (
          <>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              {t('reg.heading')}
            </Typography>
            <TextField
              label={t('reg.facilityName')}
              value={facilityName}
              onChange={(e) => setFacilityName(e.target.value)}
              fullWidth
              margin="normal"
            />
            <TextField
              label={t('reg.contact')}
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
              margin="normal"
            />
            <TextField
              label={t('reg.phone')}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              fullWidth
              margin="normal"
            />
            <TextField
              label={t('reg.position')}
              value={position}
              onChange={(e) => setPosition(e.target.value)}
              fullWidth
              margin="normal"
            />
            <Button onClick={handleSubmit} variant="contained" color="primary" fullWidth>
              {t('common:action.submit')}
            </Button>
            {message && (
              <Typography variant="body1" align="center" sx={{ mt: 2 }}>
                {message}
              </Typography>
            )}
          </>
        )}
      </Box>
    </RootLayout>
  );
};

export default RegClinic;